<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <g>
      <path d="M41.318,23.329a9.318,9.318,0,0,0-18.636,0v3.12H41.318Z" fill="none"/>
      <path class="filled" d="M52.434,26.449H46.246v-3.12a14.246,14.246,0,0,0-28.492,0v3.12H11.566a2.774,2.774,0,0,0-2.774,2.774V53.271a2.773,2.773,0,0,0,2.774,2.773H52.434a2.773,2.773,0,0,0,2.774-2.773V29.223A2.774,2.774,0,0,0,52.434,26.449Zm-29.752-3.12a9.318,9.318,0,0,1,18.636,0v3.12H22.682ZM34.948,45.611a2.774,2.774,0,0,1-2.774,2.774h-.348a2.774,2.774,0,0,1-2.774-2.774V36.883a2.774,2.774,0,0,1,2.774-2.774h.348a2.774,2.774,0,0,1,2.774,2.774Z" fill="currentColor"/>
    </g>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
